// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fbzdJmssUjsVanCTN9fW::-webkit-inner-spin-button,
.fbzdJmssUjsVanCTN9fW::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/InputCoordinates/components/components/CoordinateInput.module.less"],"names":[],"mappings":"AAAA;;EAEE,wBAAA;EACA,SAAA;AACF","sourcesContent":[".hideSpinButtons::-webkit-inner-spin-button,\n.hideSpinButtons::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var hideSpinButtons = `fbzdJmssUjsVanCTN9fW`;
export default ___CSS_LOADER_EXPORT___;
